module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-bd6ef825721ebd200a262e76fe96a0e8.png";